import React from 'react';
import { Card } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { Skeleton } from '@fortress-technology-solutions/fortress-component-library/Atoms';

import HouseholdMemberCardDetails from './HouseholdMemberCardDetails';
import HouseholdMemberCardContent from './HouseholdMemberCardContent';
import HouseholdMemberListItem from './HouseholdMemberListItem';
import ApplicationChecklistModal from '../ApplicationChecklistModal';
import useModalProps from '../../../hooks/useModalProps';
import ApprovalStatusModal from '../ApprovalStatusModal';

const HouseholdMemberCardSkeleton = (
  <>
    <HouseholdMemberCardContent
      avatar={<Skeleton variant="circular" width={40} height={40} />}
      title={<Skeleton width={100} height={30} />}
      subheader={<Skeleton width={180} />}
    >
      {Array(2)
        .fill()
        .map((_, index) => (
          <HouseholdMemberListItem
            key={index}
            icon={<Skeleton variant="circular" width={24} height={24} />}
            primaryText={<Skeleton width={150 + index * 25} height={30} />}
            actionIcon={<Skeleton variant="circular" width={24} height={24} />}
          />
        ))}
    </HouseholdMemberCardContent>
  </>
);

const HouseholdMemberCard = ({
  applicationComplete,
  checklistApproved,
  downloadAffordaPortalApplicationPDF,
  handleEditApplicationForm,
  isAdult,
  isLoading,
  isResident,
  leaseSignerType,
  name,
  portalUserId,
  affordaPortaV1,
  applicant,
  checklistItems,
  applicationDecisionStatuses,
  handleMultipleChecklistOptionsChange,
  propertyId,
  organizationId,
  isCanceled,
  isPending,
  deniedReasons,
  approveApplicant,
  cancelApplicant,
  selectedProperty,
}) => {
  const applicationChecklistModalProps = useModalProps();
  const approvalStatusModalProps = useModalProps();
  return (
    <Card sx={{ minWidth: 330 }}>
      <AsyncBox Skeleton={HouseholdMemberCardSkeleton} loading={isLoading}>
        <HouseholdMemberCardDetails
          applicationComplete={applicationComplete}
          checklistApproved={checklistApproved}
          downloadAffordaPortalApplicationPDF={
            downloadAffordaPortalApplicationPDF
          }
          handleEditApplicationForm={handleEditApplicationForm}
          isAdult={isAdult}
          isResident={isResident}
          leaseSignerType={leaseSignerType}
          name={name}
          portalUserId={portalUserId}
          affordaPortaV1={affordaPortaV1}
          handleChecklistClick={applicationChecklistModalProps.handleOpen}
          handleApprovalStatusClick={approvalStatusModalProps.handleOpen}
          isLoading={isLoading}
          isCanceled={isCanceled}
          isPending={isPending}
          deniedReasons={deniedReasons}
          applicant={applicant}
          selectedProperty={selectedProperty}
        />
      </AsyncBox>
      <ApplicationChecklistModal
        checklistItems={checklistItems}
        applicant={applicant}
        applicationDecisionStatuses={applicationDecisionStatuses}
        handleMultipleChecklistOptionsChange={
          handleMultipleChecklistOptionsChange
        }
        isResident={isResident}
        organizationId={organizationId}
        propertyId={propertyId}
        isCanceled={isCanceled}
        {...applicationChecklistModalProps}
      />
      <ApprovalStatusModal
        applicant={applicant}
        approveApplicant={approveApplicant}
        cancelApplicant={cancelApplicant}
        deniedReasons={deniedReasons}
        checklistApproved={checklistApproved}
        applicationComplete={applicationComplete}
        {...approvalStatusModalProps}
      />
    </Card>
  );
};

export default HouseholdMemberCard;
